var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOffice = function SvgOffice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6663 5.33325H15.333V6.66659H20.6663V20.6666H15.333V21.9999H21.9997V6.66659C21.9997 6.31296 21.8592 5.97382 21.6092 5.72378C21.3591 5.47373 21.02 5.33325 20.6663 5.33325Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2537 2H4.08033C3.70549 2 3.346 2.1489 3.08095 2.41396C2.8159 2.67901 2.66699 3.03849 2.66699 3.41333V22H14.667V3.41333C14.667 3.03849 14.5181 2.67901 14.253 2.41396C13.988 2.1489 13.6285 2 13.2537 2ZM13.3337 20.6667H11.3337V18.6667H6.00033V20.6667H4.00033V3.41333C4.00033 3.40283 4.00239 3.39242 4.00642 3.38272C4.01044 3.37301 4.01633 3.36419 4.02376 3.35676C4.03119 3.34934 4.04 3.34344 4.04971 3.33942C4.05942 3.3354 4.06982 3.33333 4.08033 3.33333H13.2537C13.2642 3.33333 13.2746 3.3354 13.2843 3.33942C13.294 3.34344 13.3028 3.34934 13.3102 3.35676C13.3177 3.36419 13.3235 3.37301 13.3276 3.38272C13.3316 3.39242 13.3337 3.40283 13.3337 3.41333V20.6667Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 5.33325H6.66634V6.66659H5.33301V5.33325Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.33325H9.33333V6.66659H8V5.33325Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 5.33325H12.0003V6.66659H10.667V5.33325Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 8.66675H6.66634V10.0001H5.33301V8.66675Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.66675H9.33333V10.0001H8V8.66675Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 8.66675H12.0003V10.0001H10.667V8.66675Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 12H6.66634V13.3333H5.33301V12Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H9.33333V13.3333H8V12Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 12H12.0003V13.3333H10.667V12Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 15.3333H6.66634V16.6666H5.33301V15.3333Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.3333H9.33333V16.6666H8V15.3333Z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 15.3333H12.0003V16.6666H10.667V15.3333Z",
    fill: "currentColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.333 8.66675H16.6663V10.0001H15.333V8.66675Z",
    fill: "currentColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.66675H19.3333V10.0001H18V8.66675Z",
    fill: "currentColor"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.333 12H16.6663V13.3333H15.333V12Z",
    fill: "currentColor"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12H19.3333V13.3333H18V12Z",
    fill: "currentColor"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.333 15.3333H16.6663V16.6666H15.333V15.3333Z",
    fill: "currentColor"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.3333H19.3333V16.6666H18V15.3333Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOffice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/office.78a98fac.svg";
export { ForwardRef as ReactComponent };